import { type PreloadedState } from '@reduxjs/toolkit';

import { type TReduxActions, type TReduxState, type TReduxStore, getReduxStore } from '@/packages/redux-state/store';

import { type IReduxStateProvider } from '../IReduxStateProvider';

export class ReduxState implements IReduxStateProvider {
  public static readonly key = 'reduxState';

  public readonly store: TReduxStore;

  public constructor(preloadedState: PreloadedState<TReduxState> | undefined, devTools: boolean) {
    this.store = getReduxStore(preloadedState, devTools);
  }

  public getState(): TReduxState {
    return this.store.getState();
  }

  public dispatch(action: TReduxActions): void {
    this.store.dispatch(action);
  }
}
